import { render } from "./FormRadio.vue?vue&type=template&id=3d4bb150"
import script from "./FormRadio.vue?vue&type=script&lang=js"
export * from "./FormRadio.vue?vue&type=script&lang=js"

import "./FormRadio.vue?vue&type=style&index=0&id=3d4bb150&lang=scss"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__